import { Component, Vue} from 'vue-property-decorator';

@Component
export default class DimensionsMixin extends Vue {
  get dimensions() {
    return {
      'campaigns': this.t('Campaigns'),
      'offers': this.t('Offers'),
      'landings': this.t('Landings'),
      'hour-of-day': this.t('Hour Of Day'),
      'day-of-week': this.t('Day Of Week'),
      'flows': this.t('Flows'),
      'traffic-sources': this.t('Traffic Sources'),
      'affiliate-networks': this.t('Affiliate Networks'),
      'day': this.t('Day'),
      'month': this.t('Month'),
      'custom1': this.t('Custom 1'),
      'custom2': this.t('Custom 2'),
      'custom3': this.t('Custom 3'),
      'custom4': this.t('Custom 4'),
      'custom5': this.t('Custom 5'),
      'custom6': this.t('Custom 6'),
      'custom7': this.t('Custom 7'),
      'custom8': this.t('Custom 8'),
      'custom9': this.t('Custom 9'),
      'custom10': this.t('Custom 10'),
      'referrers': this.t('Referrers'),
      'states': this.t('State / region'),
      'referrer-domains': this.t('Referrer Domain'),
      'countries': this.t('Countries'),
      'mobile-carriers': this.t('Mobile Carriers'),
      'connection-types': this.t('Connection Types'),
      'cities': this.t('Cities'),
      'isps': this.t('ISP'),
      'browser-versions': this.t('Browser Versions'),
      'oses': this.t('OS'),
      'os-versions': this.t('OS Versions'),
      'browsers': this.t('Browsers'),
      'device-models': this.t('Device Models'),
      'device-types': this.t('Device Types'),
      'languages': this.t('Languages'),
      'device-vendors': this.t('Device Vendors'),
      'ips': this.t('IP'),
      'subnet-small': this.t('Subnet Small'),
      'subnet-big': this.t('Subnet Big'),
      'screen-resolutions': this.t('Screen Resolutions'),
      'useragents': this.t('User Agents'),
      'live-visits': this.t('Live Visits'),
      'live-clicks': this.t('Live Clicks'),
      'n_a': this.t('n/a'),
      'conversions': this.t('Conversions'),
      'errors': this.t('Errors'),
      'flow_rules': this.t('Flow rule'),
      'flow_rule_paths': this.t('Flow path')
    }
  }
}